<template lang="pug">
b-navbar#nav
    template(slot="brand")
        b-navbar-item(tag="div", :to="{ path: '/' }")
          router-link(:to="{ path: '/' }")
            img(src="@/assets/logo.png")
    template(slot="end")
        b-navbar-item(tag="div")
            b-button(type="is-light", icon-right="question-circle" @click="showHelp")
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

library.add(faQuestionCircle);

export default {
  name: "Navbar",
  methods: {
    // Show the help dialog
    showHelp() {
      this.$buefy.dialog.alert({
        title: "Line Monitor Dashboard",
        message: "This site is for the Line Monitors of Duke University.",
        type: "is-duke"
      });
    }
  }
};
</script>

<style lang="scss">
#nav {
  padding: 20px;
}
</style>
